import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { DebugInfoSectionProps } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/DebugInfo/DebugInfoSectionProps";

export const debugInfoSectionPropsILeanProductTileAdapter = (
  productTile: ILeanProductTile
): DebugInfoSectionProps => {
  return {
    productToken: productTile.product?.token,
    promotedBy: productTile.product?.promoted_by,
    debugInfo: productTile.retrieval_and_ranking_debug_info,
  };
};
